__turbopack_context__.v({
  "icon": "CrossButton-module__h83FMW__icon",
  "navItem": "CrossButton-module__h83FMW__navItem",
});
